// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import PaymentElementController from './payment_element_controller';
import GoodToKnowController from './good_to_know_controller';
import ContactDetailsController from './contact_details_controller';

application.register('payment-element', PaymentElementController);
application.register('good-to-know', GoodToKnowController);
application.register('contact-details', ContactDetailsController);
